export default {
  default: {
    title: 'Edit Item',
    titleSecondLine: 'Details',
    nonEditable: 'Selected item is not editable.',
  },
}
